<template>
  <div id="selectpage" style="background: #eee">
    <b-container class="container">
      <div class="cardOriGroup">
        <div>
          <input
            id="ori_h"
            type="radio"
            v-model="cardOri"
            name="cardOriRd"
            value="0"
          />
          <label for="ori_h">横版</label>
          <span style="padding: 0 20px">/</span>
          <input
            id="ori_v"
            type="radio"
            v-model="cardOri"
            name="cardOriRd"
            value="1"
          />
          <label for="ori_v">竖版</label>
        </div>
      </div>

      <div>
        <b-row style="margin-right: -35px; margin-left: -35px">
          <b-col
            :cols="cardOri == 0 ? '6' : '4'"
            :class="
              cardOri == 0
                ? 'mx-auto text-center uploadGroup'
                : 'mx-auto text-center uploadGroupV'
            "
            @click="selectCardface()"
            style="padding: 25px 0px"
          >
            <b-img
              class="mt-2"
              src="static/qlbank/img_upload.png"
              style="width: 55px; height: 51px"
            ></b-img>
            <div class="mt-2" style="font-weight: normal; font-size: 12px">
              <b>点此上传图片</b>
            </div>
          </b-col>
        </b-row>
      </div>

      <div class="shangchuan" style="margin-top: 200px; background: #fff">
        <div style="padding: 20px 15px">
          <h6 style="font-size: 20px">上传须知</h6>
          <div style="padding: 10px 15px; font-size: 14px; color: #777777">
            <div>1.图片最小分辨率为{{ pxLimit }}像素，最大为10MB</div>
            <div>2.涉黄、涉暴、涉政等违规图片将无法审核通过</div>
          </div>
        </div>
      </div>
      <div v-show="false">
        <form ref="imgUploadForm">
          <input
            ref="uploadInput"
            type="file"
            accept="image/*"
            @change.prevent.stop="upload"
          />
        </form>
      </div>

      <b-modal
        ok-only
        ref="model_error"
        title="提示"
        @ok="handleOk"
        ok-title="确定"
      >
        <p class="my-4">{{ errorMsg }}</p>
      </b-modal>
      <b-modal
        ok-only
        ref="model_frequency"
        title="提示"
        @ok="frequency()"
        ok-title="确定"
      >
        <p class="my-4">{{ errorMsg }}</p>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import axios from "axios";
var config = require("../../common/config.js");
export default {
  name: "SelectCardface_zy",
  data() {
    return {
      bankSerialNumber: "", //序列号、唯一标识
      bankCode: "", //银行编号
      messageData: "", //手机号
      selectParam: "",
      cardOri: 0,
      pxLimit: "1075 * 686",
      imgWlimit: 1075,
      imgHlimit: 686,
      imgSizeLimit: 10 * 1024 * 1024,
      errorMsg: "",
      // 加密信息
      data1: "",
      data2: "",
      // 解密信息
      sqjNo: "",
      cardLevel: "",
      cardProduct: "",
      creditDate: "",
    };
  },
  watch: {
    cardOri: function (newval, oldval) {
      console.log("当前版面方向：" + newval, "之前版面方向：" + oldval);
      if (newval == 0) {
        this.imgWlimit = 1075;
        this.imgHlimit = 686;
        this.pxLimit = "1075 * 686";
      } else if (newval == 1) {
        this.imgWlimit = 686;
        this.imgHlimit = 1075;
        this.pxLimit = "686 * 1075";
      }
      // console.log('imgWlimit' + this.imgWlimit)
      // console.log('imgHlimit' + this.imgHlimit)
    },
  },
  mounted: function () {
    let bank = this.$route.params.bank; //是否回退申请制卡
    if (bank == undefined) {
      this.data1 = this.$route.query.data1; //参数data1
      this.data2 = this.$route.query.data2; //参数data2
      console.log("data1:", this.data1, "data2:", this.data2);
      if (this.data1 == undefined || this.data2 == undefined) {
        this.errorMsg = "制卡数据存在问题，请联系客服";
        this.showErrorMsgFrequency();
      } else {
        this.decryption();
      }
    } else {
      console.log("sqjNo:", localStorage.getItem("sqjNo"));
    }
  },

  methods: {
    decryption() {
      let formData = new FormData();
      formData.append("bankCode", config.config_zy.bankCode);
      formData.append("data1", this.data1);
      formData.append("data2", this.data2);
      axios({
        method: "post",
        url: config.config_zy.decryptDataByZYBank,
        data: formData,
      })
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            this.sqjNo = res.data.data.sqjNo;
            localStorage.setItem("sqjNo", this.sqjNo);
            this.cardLevel = res.data.data.cardLevel;
            localStorage.setItem("cardLevel", this.cardLevel);
            this.cardProduct = res.data.data.cardProduct;
            localStorage.setItem("cardProduct", this.cardProduct);
            this.creditDate = res.data.data.creditDate;
            localStorage.setItem("creditDate", this.creditDate);
            this.applyFrequency(this.sqjNo);
          } else {
            this.errorMsg = "数据解密失败";
            this.showErrorMsg();
          }
        })
        .catch((err) => {
          this.errorMsg = "decryptDataByZYBank接口失败";
          this.showErrorMsg();
        });
    },
    applyFrequency(frequency) {
      let formData = new FormData();
      formData.append("bankCode", config.config_zy.bankCode);
      formData.append("bankSerialNumber", frequency);
      axios({
        method: "post",
        url: config.config_zy.queryOrder,
        data: formData,
      })
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            if (res.data.data == null || res.data.data.commitTimes < 3) {
            } else {
              this.errorMsg = "中原银行申请卡片次数超出限制（3次）";
              this.showErrorMsgFrequency();
            }
          } else {
          }
        })
        .catch((err) => {
          this.errorMsg = "queryOrder接口失败";
          this.showErrorMsg();
        });
    },
    upload: function (event) {
      var that = this;
      console.log(event);
      let file = event.target.files[0];
      let fileSize = file.size;
      console.log(file);
      let url = null;
      if (window.createObjectURL != undefined) {
        // basic
        url = window.createObjectURL(file);
      } else if (window.webkitURL != undefined) {
        // webkit or chrome
        url = window.webkitURL.createObjectURL(file);
      } else if (window.URL != undefined) {
        // mozilla(firefox)
        url = window.URL.createObjectURL(file);
      }
      console.log(url);
      if (fileSize > this.imgSizeLimit) {
        that.errorMsg = "图片大小不能超过10MB";
        that.showErrorMsg();
        that.resetUpload();
      } else {
        let image = new Image();
        let w, h;
        image.src = url;
        image.onload = function () {
          w = image.width; // 图片宽度
          h = image.height; // 图片高度
          image.onload = null; // 避免重复加载

          // console.log('图片宽高:' + w + '*' + h)
          // console.log('图片大小:' + (fileSize / 1024) + 'KB')
          if (w >= that.imgWlimit && h >= that.imgHlimit) {
            that.toEditCardface(url, file);
          } else {
            that.errorMsg = "图片像素不符合要求，图片的像素：" + w + "*" + h;
            that.showErrorMsg();
            that.resetUpload();
          }
        };
      }
    },
    toEditCardface: function (imgPath, file) {
      var selectParam = JSON.stringify(this.selectParam);
      this.$router.push({
        name: "EditCardface_zy",
        params: {
          imagePath: imgPath,
          bankSerialNumber: this.bankSerialNumber,
          cardOri: this.cardOri,
          file: file,
        },
      });
    },
    resetUpload: function () {
      var form = this.$refs.imgUploadForm;
      console.log(form);
      form.reset();
    },
    handleOk: function (bvModalEvt) {},
    showErrorMsgFrequency: function () {
      this.$refs["model_frequency"].show();
    },
    frequency() {
      // 在当前窗口跳转
      window.location.href =
        "https://rcm.zybank.com.cn/ccc/credit-card-web/#/home";
    },
    showErrorMsg: function () {
      this.$refs["model_error"].show();
    },
    hideErrorMsg: function () {
      this.$refs["model_error"].hide();
    },
    selectCardface: function () {
      this.resetUpload();
      this.$refs.uploadInput.click();
    },
  },
  beforeRouteLeave(to, from, next) {
    console.log("SelectCardface_zy beforeRouteLeave");
    console.log("to", to);
    console.log("from", from);
    if (to.name == "Home_zy") {
      this.$router.go(0);
    } else if (to.name != "EditCardface_zy") {
      // 重新上传卡面
      let reupload = this.$store.state.zy.reuploadCount > 0;
      if (reupload) {
        this.$store.commit("zy/decreReuploadImg");
      }
    }
    next();
  },
};
</script>

<style scoped>
#selectpage {
  left: 0;
  top: 0;
  position: absolute;
  width: 100%;
  height: 100%;
}
.container {
  padding: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}
.container .shangchuan {
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;
  /* top: 0; */
}

.uploadGroup {
  border: lightgray solid 1px;
  border-radius: 4px;
  border-style: dashed;
}
.uploadGroupV {
  border: lightgray solid 1px;
  border-radius: 4px;
  border-style: dashed;
  height: 180px;
}

.cardOriGroup {
  margin-bottom: 20px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  text-align: center;
  align-items: flex-end;
  height: 64px;
}

.cardOriGroup input {
  display: none;
}

.cardOriGroup label {
  color: gray;
  line-height: 28px;
  min-width: 20vw;
  min-height: 28px;
  text-align: center;
  border-radius: 4px;
  margin: 8px;
}

.cardOriGroup input:checked + label {
  background-size: 21px 21px;
  font-weight: bold;
  color: black;
  margin: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/zyBank/SelectCardface_zy.vue